import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { ProfileCardHeaderAvatar } from '~shared/ui/atoms';

export const avatarImage = css`
	object-fit: cover;
`;

export const Author = styled.section`
	display: flex;
	padding: 2rem;
	border-radius: var(--radius-s);
	background-color: var(--color-white-xs);
	gap: 1.2rem;

	& > :last-child {
		margin-left: auto;
	}
`;

export const AuthorAvatar = styled(ProfileCardHeaderAvatar)`
	width: 4.8rem;
	height: 4.8rem;
	margin: 0;
	font-size: var(--font-size-2xl);
`;

export const AuthorInfo = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 0.6rem;
`;
